import * as ACTION from './constants';
import * as saga from './saga';
import {takeLatest} from 'redux-saga/effects';

export default function* () {
	yield takeLatest(ACTION.CREATE_INVENTORY.REQUEST, saga.createInventoryRequest);
	yield takeLatest(ACTION.CREATE_INVENTORY.SUCCESS, saga.createInventorySuccess);
	yield takeLatest(ACTION.CREATE_INVENTORY.FAILED, saga.createInventoryFailed);
}
